import { IconButton, Stack } from "@mui/material";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useNavigate } from "react-router-dom";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useEffect, useState } from "react";
import { useDeleteRoleMutation } from "src/api/settings/roles";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import { useTranslation } from "react-i18next";
import { SettingsPermissions } from "src/constants/permissions";
import { oneBranchHasPermission } from "src/utils";

const TableActions = ({
  rowId,
  rowName,
  refetch,
  isDefault,
}: {
  rowId: number;
  rowName: string;
  refetch: Function;
  isDefault: boolean;
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const { t } = useTranslation("general");

  // APIS
  const { mutate, isPending, status, error } = useDeleteRoleMutation();

  // permissions
  const editPermission = oneBranchHasPermission(SettingsPermissions.editRole);
  const deletePermission = oneBranchHasPermission(
    SettingsPermissions.deleteRole
  );

  const navigateToEditPage = () => {
    navigate(`/settings/roles/${rowId}/edit`);
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    mutate(rowId);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleClose();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack
      direction={"row"}
      spacing={"12px"}
      width={"100%"}
      justifyContent={"center"}
    >
      {!isDefault && (
        <>
          {editPermission && (
            <IconButton onClick={navigateToEditPage}>
              <img src={EditIcon} alt="" />
            </IconButton>
          )}
          {deletePermission && (
            <IconButton onClick={handleClickOpen}>
              <img src={DeleteIcon} alt="" />
            </IconButton>
          )}
        </>
      )}

      <ConfirmPopup
        open={open}
        item={rowName}
        handleClose={handleClose}
        handleConfirm={handleDelete}
        isPending={isPending}
      />
    </Stack>
  );
};
export default TableActions;
